import ky from 'ky';

import { isCloud } from '@/consts/env';

export const isEmbeddedConsole = !isCloud && window.self !== window.top;

// This state is scoped to the current iframe document, never to browser storage.
// A new portal visit must prove the current upstream account, even with cached console tokens.
const session: { verified: boolean; connector?: Promise<boolean> } = { verified: false };

export const markConsoleCallbackVerified = () => {
  // eslint-disable-next-line @silverhand/fp/no-mutation -- only a successful callback sets this document-local flag.
  session.verified = true;
};

export const needsConsoleAccountCheck = () => isEmbeddedConsole && !session.verified;

const readConnector = async () => {
  const settings = await ky
    .get('/api/.well-known/sign-in-exp', { retry: 0, timeout: 5000 })
    .json<{ socialSignInConnectorTargets: string[] }>();

  return settings.socialSignInConnectorTargets.includes('devportal-sso');
};

export const hasPortalConnector = async () => {
  if (!isEmbeddedConsole) {
    return false;
  }

  // eslint-disable-next-line @silverhand/fp/no-mutation -- concurrent sign-in hooks share one discovery request.
  session.connector ??= readConnector();

  return session.connector;
};
